import { render, staticRenderFns } from "./Caution.vue?vue&type=template&id=4677d02b&scoped=true"
import script from "./Caution.vue?vue&type=script&lang=js"
export * from "./Caution.vue?vue&type=script&lang=js"
import style0 from "./Caution.vue?vue&type=style&index=0&id=4677d02b&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4677d02b",
  null
  
)

export default component.exports